"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = updateHiddenSeriesIndices;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.number.constructor");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

var _logger = _interopRequireDefault(require("../../logger"));

var _seriesData = _interopRequireDefault(require("../../series-data"));

function updateHiddenSeriesIndices(_ref) {
  var chart = _ref.chart,
      chartData = _ref.chartData,
      chartInstance = _ref.chartInstance,
      chartOptions = _ref.chartOptions,
      hiddenSeriesIndices = _ref.hiddenSeriesIndices;

  // Chart contract validation
  if ((0, _typeof2.default)(chart) !== 'object') {
    throw new TypeError("chart must be an instance of an MwVisualization. Provided: ".concat(chart));
  }

  if (typeof chart.setChartOptions !== 'function') {
    throw new TypeError('chart must have a \'setChartOptions\' method.');
  }

  _argumentContracts.default.assertArrayOf(chartData, _seriesData.default, 'chartData');

  if ((0, _typeof2.default)(chartInstance) !== 'object') {
    throw new TypeError("chartInstance must be the internal Highcharts instance. Provided: ".concat(chartInstance));
  }

  if ((0, _typeof2.default)(chartOptions) !== 'object') {
    throw new TypeError("chartOptions must be valid Chart Options. Provided: ".concat(JSON.stringify(chartOptions)));
  }

  _argumentContracts.default.assertArrayOf(chartOptions.hiddenSeriesIndices, Number, 'chartOptions.hiddenSeriesIndices');

  _argumentContracts.default.assertArrayOf(hiddenSeriesIndices, Number, 'hiddenSeriesIndices');

  try {
    chart.error = false;

    if (chartInstance === null) {
      throw new Error('The chart must be successfully rendered before it can be updated');
    }

    chart.setChartOptions(Object.assign({}, chartOptions, {
      hiddenSeriesIndices: hiddenSeriesIndices
    }));
    chartData.forEach(function (__, seriesIndex) {
      if (hiddenSeriesIndices.some(function (index) {
        return index === seriesIndex;
      })) {
        chartInstance.series[seriesIndex].hide();
      } else {
        chartInstance.series[seriesIndex].show();
      }
    });
  } catch (error) {
    chart.error = true;

    _logger.default.error('Chart failed to render.', error);

    chartOptions.onError(error);
  }
}